// Navigation interne des écrans des achats (lot L4-C, M15) : fournisseurs, consultations et offres
// (avec les besoins validés à consulter), contrats, commandes, livraisons et factures.
import { Lien } from '@cc/ui';
import styles from './achats.module.css';

const ENTREES = [
  { id: 'consultations', libelle: 'Besoins et consultations', href: '/achats' },
  { id: 'fournisseurs', libelle: 'Fournisseurs', href: '/achats/fournisseurs' },
  { id: 'contrats', libelle: 'Contrats', href: '/achats/contrats' },
  { id: 'commandes', libelle: 'Commandes, livraisons et factures', href: '/achats/commandes' },
] as const;

export function NavigationAchats({ actif }: { actif: (typeof ENTREES)[number]['id'] }) {
  return (
    <nav className={styles.navigation} aria-label="Marchés publics et fournisseurs">
      {ENTREES.map((e) => (
        <Lien key={e.id} href={e.href} aria-current={e.id === actif ? 'page' : undefined} className={e.id === actif ? styles.lienActif : styles.lien}>
          {e.libelle}
        </Lien>
      ))}
    </nav>
  );
}
